import { auth } from '@/lib/firebase';
import { WORKER_API_BASE_URL } from '@/lib/worker-api';

const API_BASE = WORKER_API_BASE_URL;

type CategoryBody = {
  name: string;
  weights: Record<string, number>;
};

async function authorizedJson(path: string, body: unknown) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw Object.assign(new Error('Not authenticated'), { code: 'auth/not-authenticated' });
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({})) as { error?: string; message?: string };
    throw Object.assign(new Error(errorBody.message || `Request failed with ${response.status}`), {
      status: response.status,
      code: errorBody.error,
    });
  }

  return response.json();
}

export function createEntertainmentCategory(body: CategoryBody) {
  return authorizedJson('/api/entertainment/categories', body);
}

export function updateEntertainmentCategory(categoryId: string, body: CategoryBody) {
  return authorizedJson(`/api/entertainment/categories/${encodeURIComponent(categoryId)}`, body);
}

export function deleteEntertainmentCategory(categoryId: string, body: { reason: string }) {
  return authorizedJson(`/api/entertainment/categories/${encodeURIComponent(categoryId)}/delete`, body);
}
